import { IClassname } from '@/lib/shared/model/classname';

export const Cleaning = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3962 13.5647C16.2088 13.8892 16.1192 14.2659 16.1324 14.6732C16.1456 15.0805 16.2613 15.5106 16.473 15.9387C16.6847 16.3669 16.9882 16.7848 17.3662 17.1686C17.7442 17.5524 18.1893 17.8946 18.676 18.1756C19.1628 18.4567 19.6817 18.671 20.203 18.8065C20.7244 18.9419 21.2381 18.9958 21.7148 18.9651C22.1914 18.9343 22.6217 18.8196 22.9811 18.6273C23.3404 18.435 23.6218 18.1691 23.8092 17.8446C23.9965 17.5201 24.0861 17.1434 24.073 16.7361C24.0598 16.3287 23.944 15.8987 23.7323 15.4706C23.5206 15.0424 23.2171 14.6245 22.8391 14.2407C22.4611 13.8569 22.016 13.5147 21.5293 13.2336C21.0426 12.9526 20.5237 12.7383 20.0023 12.6028C19.4809 12.4674 18.9672 12.4135 18.4906 12.4442C18.0139 12.475 17.5836 12.5897 17.2243 12.782C16.8649 12.9742 16.5835 13.2402 16.3962 13.5647Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8087 17.8454C23.8087 17.8454 21.6688 21.5519 18.8327 22.6604C18.3935 22.7752 17.983 22.98 17.6272 23.2618C17.2713 23.5436 16.9779 23.8962 16.7654 24.2974C16.7345 24.3763 16.683 24.4456 16.6162 24.4979C16.5495 24.5503 16.47 24.5838 16.3859 24.5951C16.3019 24.6064 16.2163 24.595 16.1382 24.5621C16.06 24.5291 15.9921 24.4759 15.9414 24.4079C14.7786 22.8428 13.1257 19.228 16.3952 13.5636"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99992 5.83082L16.3955 13.5648"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 28.9997C2.92826 28.9997 3.8185 28.6424 4.47487 28.0064C5.13125 27.3704 5.5 26.5078 5.5 25.6084C5.5 26.5078 5.86875 27.3704 6.52513 28.0064C7.1815 28.6424 8.07174 28.9997 9 28.9997C9.92826 28.9997 10.8185 28.6424 11.4749 28.0064C12.1313 27.3704 12.5 26.5078 12.5 25.6084C12.5 26.5078 12.8687 27.3704 13.5251 28.0064C14.1815 28.6424 15.0717 28.9997 16 28.9997C16.9283 28.9997 17.8185 28.6424 18.4749 28.0064C19.1313 27.3704 19.5 26.5078 19.5 25.6084C19.5 26.5078 19.8688 27.3704 20.5251 28.0064C21.1815 28.6424 22.0717 28.9997 23 28.9997C23.9283 28.9997 24.8185 28.6424 25.4749 28.0064C26.1313 27.3704 26.5 26.5078 26.5 25.6084C26.5 26.5078 26.8688 27.3704 27.5251 28.0064C28.1815 28.6424 29.0717 28.9997 30 28.9997"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
